var map = {
	"./en/common": 23172,
	"./en/common.json": 23172,
	"./en/unit": 49639,
	"./en/unit.json": 49639,
	"./it-IT/common": 57888,
	"./it-IT/common.json": 57888,
	"./it-IT/seo": 88051,
	"./it-IT/seo.json": 88051,
	"./it-IT/unit": 16698,
	"./it-IT/unit.json": 16698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80706;